/**
 * AreaDeRisco
 */
import {$, HttpBody, ID, Resource, ResponseSerialize} from 'simpli-web-sdk'
import {
  ValidationMaxLength,
  ValidationRequired,
} from 'simpli-web-sdk'
import AreaDeRiscoSchema from '@/schema/AreaDeRisco.schema'
import Responsavel from '@/model/resource/Responsavel'

export default class AreaDeRisco extends Resource {

  get $schema() {
    return AreaDeRiscoSchema(this)
  }

  get $id() {
    return this.idAreaDeRiscoPk
  }
  set $id(val: ID) {
    this.idAreaDeRiscoPk = val
  }

  get idReponsavelFk() {
    return this.responsavel!.idResponsavelPk
  }
  set idResponsavelFk(value: ID) {
    this.responsavel!.idResponsavelPk = value
  }

  static async persistLoteAreaDeRisco(listToPersist: AreaDeRisco[], spinner = 'persistLoteAreaDeRisco') {
    const fetch = async () => {
      return await new HttpBody(Number).POST(`/user/lote-area-de-risco`, listToPersist)
    }

    return await $.await.run(fetch, spinner)
  }
  readonly $name: string = 'AreaDeRisco'

  readonly $endpoint: string = '/user/area-de-risco{/id}'

  idAreaDeRiscoPk: ID = 0

  @ValidationMaxLength(8)
  cepInicial: string = ''

  @ValidationMaxLength(8)
  cepFinal: string = ''

  @ResponseSerialize(Responsavel)
  responsavel: Responsavel | null = null

  ativo: boolean = true

  notificarNoApp: boolean = false

  notificarNoPainel: boolean = false

  dataCadastro: string | null = null

  async persistAreaDeRisco(spinner = 'persistAreaDeRisco') {
    const fetch = async () => {
      await this.validate()
      return await this.POST(`/user/area-de-risco`, this)
    }

    return await $.await.run(fetch, spinner)
  }

  async getAreaDeRisco(id: number | string, spinner = 'getAreaDeRisco') {
    const fetch = async () => await this.GET(`/user/area-de-risco/${id}`)
    return await $.await.run(fetch, spinner)
  }
}
